import { $ } from "venuescanner-js/tools/elemental";
import { scrollToElement } from "venuescanner-js/vanilla/components/animateScroll";

export const GalleryViewer = function (galleryContainer) {
  this.galleryContainer = galleryContainer;
  this.images = [];
  this.getFromGallery = function () {
    const images = $(this.galleryContainer)
      .find("figure img")
      .get()
      .map((img) => {
        return {
          img: img.getAttribute("src") || img.getAttribute("data-src"),
          title: img.alt,
        };
      });
    return {
      target: $("<div></div>").hide(),
      images: images.map((image) => {
        image.fullsize = image.img.replace(/\/med_/, "/main_");
        image.thumbnail = image.img.replace(/\/med_/, "/med_");
        return image;
      }),
    };
  };
  this.init = function () {
    const { target, images } = this.getFromGallery();
    $(this.galleryContainer).append(
      $(
        `<button>See ${
          images.length == 1 ? "this" : `all ${images.length}`
        } photo${images.length == 1 ? "" : "s"}</button>`
      )
        .attr("type", "button")
        .addClass("show-gallery-button")
        .click(() => {
          this.open();
        })
    );
    this.images = images;
    this.target = $(target);
    $(this.galleryContainer)
      .find("button.threed-tour")
      .click(() => {
        scrollToElement(document.getElementById("matterport"));
      });
  };
  this.open = function () {
    const buttonContainer = $("<div></div>").addClass("popup-gallery-buttons");
    const button = $("<button></button>");
    this.target
      .empty()
      .addClass("noSwiper")
      .addClass("popup-gallery")
      .append(buttonContainer)
      .append(
        button.addClass("closeButton").click(() => {
          this.close();
        })
      )
      .click((e) => {
        if (e.target === this) {
          this.target.hide();
        }
      })
      .show();
    buttonContainer.click(function (e) {
      if (e.target === this) {
        this.target.hide();
      }
    });
    this.images.forEach((image) => {
      (function (img) {
        img.button = $("<button></button>")
          .attr("type", "button")
          .attr("sliptitle", img.title)
          .click(() => {
            this.display(img);
          });
        buttonContainer.append(img.button);
        img.thumb = $("<img></img>")
          .attr("src", img.thumbnail)
          .bind("load", () =>
            img.button
              .css({ backgroundImage: "url(" + img.thumbnail + ")" })
              .addClass("loaded")
          );
      }.apply(this, [image]));
    });
    $(this.galleryContainer).append(this.target);
    // this.target.fadeIn(300)
  };
  this.close = function () {
    this.target.hide();
  };
  this.frame = null;
  this.blockout = null;
  this.index = null;
  this.render = function () {
    if (this.frame === null) {
      this.frame = $("<div></div>").addClass("imageFrame");
      this.blockout = $("<div></div>")
        .addClass("image-blockout")
        .click((e) => {
          if (e.target === this) {
            this.blockout.remove();
            this.blockout = this.frame = null;
          }
        })
        .hide();
      const closeButton = $("<button></button>")
        .attr("type", "button")
        .addClass("closeButton")
        .click(() => {
          this.blockout.remove();
          this.blockout = this.frame = null;
        });
      this.next = $("<button></button>")
        .attr("type", "button")
        .addClass("next")
        .click(() => {
          if (this.index < this.images.length - 1)
            this.display(this.images[this.index + 1]);
        });
      this.prev = $("<button></button>")
        .attr("type", "button")
        .addClass("prev")
        .click(() => {
          if (this.index > 0) this.display(this.images[this.index - 1]);
        });
      this.blockout
        .append(this.frame)
        .append(this.next)
        .append(this.prev)
        .append(closeButton);
      $(document.body).append(this.blockout);
    }
    this.blockout.show();
  };
  this.display = function (image) {
    this.render();
    this.index = this.images.indexOf(image);
    if (this.index > 0) {
      this.frame.addClass("allowPrev");
      this.prev.css({
        backgroundImage: "url(" + this.images[this.index - 1].thumbnail + ")",
      });
    } else {
      this.frame.removeClass("allowPrev");
    }
    if (this.index < this.images.length - 1) {
      this.frame.addClass("allowNext");
      this.next.css({
        backgroundImage: "url(" + this.images[this.index + 1].thumbnail + ")",
      });
    } else {
      this.frame.removeClass("allowNext");
    }
    this.frame.addClass("loading");

    const present = () => {
      const img = $("<img></img>").get(0);
      img.style = "touch-action: none";
      this.frame.append(
        $(img)
          .attr("src", image.fullsize)
          .hide()
          .bind("load", () => {
            const s = { w: 1, h: 1 };
            image.width = img.width;
            image.height = img.height;
            if (img.width > this.blockout.width())
              s.w = this.blockout.width() / img.width;
            if (img.height > this.blockout.height())
              s.h = this.blockout.height() / img.height;
            let scale = 1;
            if (s.w < 1) scale = s.w;
            if (s.h < 1 && s.h < scale) scale = s.h;
            const w = Math.floor(img.width * scale);
            $(img)
              .css({
                width: w,
              })
              .show();
            this.frame.removeClass("loading");
          })
      );
    };

    const oldimg = this.frame.find("img");
    if (oldimg.get().length == 0) {
      present();
    } else {
      oldimg.remove();
      present();
    }
  };
  this.init();
};
